import * as React from "react";
const IconSaveVideo = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.98633 7.99243C2.98633 5.78329 4.77719 3.99243 6.98633 3.99243H13.9863C16.1955 3.99243 17.9863 5.78329 17.9863 7.99243V15.9924C17.9863 18.2016 16.1955 19.9924 13.9863 19.9924H6.98633C4.77719 19.9924 2.98633 18.2016 2.98633 15.9924V7.99243Z"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
    />
    <path
      d="M17.9863 9.32577L19.5273 7.68211C20.7673 6.3594 22.9863 7.23692 22.9863 9.04999V14.9349C22.9863 16.7479 20.7673 17.6255 19.5273 16.3028L17.9863 14.6591V9.32577Z"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
    />
    <path
      d="M13.9863 9.99243C13.9863 11.097 13.0909 11.9924 11.9863 11.9924C10.8818 11.9924 9.98633 11.097 9.98633 9.99243C9.98633 8.88786 10.8818 7.99243 11.9863 7.99243C13.0909 7.99243 13.9863 8.88786 13.9863 9.99243Z"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
    />
  </svg>
);
export default IconSaveVideo;
